// extracted by mini-css-extract-plugin
export var copy = "footer-module--copy--5e14d";
export var copyright = "footer-module--copyright--37395";
export var footer = "footer-module--footer--a2fe4";
export var footerFlex = "footer-module--footerFlex--41fe9";
export var links = "footer-module--links--c97aa";
export var logo = "footer-module--logo--9ab9c";
export var logoImage = "footer-module--logoImage--63048";